module.exports = __webpack_public_path__ + "img/8.d9d0758c.jpg";